import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./style.css";
import Home from "./components/Home";
import Order from "./components/Order";
import Cart from "./components/Cart";
import Page404 from "./components/Page404";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

function App() {
  return (
    <React.Fragment>
      <Router>
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/table/:ID" component={Home} />
          <Route path="/order" component={Order} />
          <Route path="/cart" component={Cart} />
          <Route component={Page404} />
        </Switch>
      </Router>
    </React.Fragment>
  );
}

export default App;
